/* eslint-disable no-extend-native */
import { createModule } from 'redux-modux'

const initialState = {
  activeComponent: 'Menu',
  custId: `${Date.now() * Math.floor(Math.random() * 100)}`,
  uId: `SPC${Date.now() * Math.floor(Math.random() * 100)}`,
  isFirstPartnerLoad: true,
  saleInfo: {
    // salesmancode: '',
    // orgcode: 'SPC',
    // companycode: 'ALLINONE',
    // warehousecode: 'R082',
    // divisionSale: 'E'
  }
}

const setActiveComponent = (state, actions) => ({
  ...state,
  activeComponent: actions.activeComponent
})

const setSaleInfo = (state, actions) => ({
  ...state,
  saleInfo: actions.data
})

const setPartnerLoad = (state, actions) => ({
  ...state,
  isFirstPartnerLoad: actions.data
})

const handlers = {
  setActiveComponent,
  setSaleInfo,
  setPartnerLoad
}

export default createModule({ moduleName: 'home', initialState, handlers })